import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  ChartContainer,
  ProgressCourseContainer,
  Chart,
  ProgressBarContainer,
  StateLabel,
  Legend,
  Percentage,
} from './style';
import { generalChartConfig } from '../../../utils/course-state';
import { DoughnutChart } from '../../components';
import Text from '../Text';
import { generateColorPalette } from '../../../utils/colors';
import { formatNumberToK } from '../../../utils/charts';

const options = {
  cutout: '60%',
  rotation: 180,
};

const calcPercentages = (data, total_items) => {
  const keys = Object.keys(data);
  if (keys?.length <= 0) return [];
  let offset = 0;
  const percentages = [];

  keys.forEach((key) => {
    percentages.push({
      p: Math.round((data[key] / total_items) * 100),
      deg: offset + (data[key] / total_items) * 180,
    });
    offset += (data[key] / total_items) * 360;
  });

  return percentages;
};

const CircularStats = ({
  data = {},
  size = 180,
  circumference = 360,
  mt = 24,
  hasSelect = false,
  chartOnly = false,
  dataLabels = false,
  label,
  showLegendValues,
}) => {
  const [opacity, setOpacity] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      setOpacity(1);
    }, 2000);
  }, []);
  if (Object.values(data)?.length <= 0) {
    return (
      <ChartContainer>
        <ProgressCourseContainer size={size}>
          <p className="number">0</p>
          <p>{label}</p>
        </ProgressCourseContainer>
      </ChartContainer>
    );
  }
  const formattedData = generalChartConfig(data, dataLabels);
  const total_items =
    Object.values(data)?.reduce((acc, v) => {
      acc += Number(v);
      return acc;
    }, 0) || 0;

  const colors = generateColorPalette(Object.keys(data)?.length);

  return (
    <Container size={size} mt={mt}>
      <ChartContainer className={hasSelect ? 'has-select' : ''}>
        <ProgressCourseContainer size={size}>
          <p className="number">{formatNumberToK(total_items)}</p>
          <p>{label}</p>
        </ProgressCourseContainer>
        <Chart size={size}>
          <DoughnutChart
            config={formattedData.config}
            customOptions={{ ...options, circumference }}
            showTooltip
          />
          {calcPercentages(data, total_items).map((item, i) => (
            <div key={`percentage-${i}`}>
              {item.p > 0 && (
                <Percentage rotate={item.deg} size={size} style={{ opacity }}>
                  <Text type="b3">{item.p}%</Text>
                </Percentage>
              )}
            </div>
          ))}
        </Chart>
      </ChartContainer>

      {!chartOnly && (
        <ProgressBarContainer>
          {(Object.keys(formattedData.dataset) || []).map((key, i) => (
            <StateLabel key={key}>
              <Legend color={colors[i]} />
              <Text type="b5">
                {key}
                {showLegendValues ? `: ${data[key]}` : ''}
              </Text>
            </StateLabel>
          ))}
        </ProgressBarContainer>
      )}
    </Container>
  );
};

CircularStats.propTypes = {
  data: PropTypes.object,
  dataLabels: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  label: PropTypes.string,
  size: PropTypes.number,
  circumference: PropTypes.number,
  showLegendValues: PropTypes.bool,
  mt: PropTypes.number,
  hasSelect: PropTypes.bool,
  chartOnly: PropTypes.bool,
};

export default CircularStats;
